/**
 * Created by ok on 8/21/17.
 */
import React from 'react';
import { ButtonText } from '../buttons';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

/**
 * FlatButton base component.
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const FlatButton = ( {text, ...props} ) => {

    const StyledButton = styled(Button)`
        color: ${props => props.theme.palette.primary[800]};
        font-weight: normal;
    `;

    return (
        <StyledButton {...props} >
            <ButtonText buttonText={text} />
        </StyledButton>
    );
};

export default FlatButton;



// WEBPACK FOOTER //
// ./src/components/buttons/FlatButton.js